import { useQuery } from 'react-query'
import queryString from 'query-string'

import { apiFetchUnauthorized, omitEmpty } from 'lib/action-helpers'
import { INVITATION, invitationPaths } from './index'
import { paths } from '../index'
import { useQuery as useQueryParams } from 'lib/hooks/utils'

const getInvitations = async (email, token) => {
  const query = queryString.stringify(omitEmpty({
    email,
    token
  }))
  return await apiFetchUnauthorized(paths.filter(invitationPaths.invitations(), query))
}

export const useInvitationQuery = () => {
  const params = useQueryParams()
  const token = params.get('token')
  const email = params.get('email')

  return useQuery(
    [INVITATION, token, email],
    () => getInvitations(email, token),
    {
      staleTime: Infinity,
      enabled: !!email && !!token,
      retry: false
    }
  )
}
